import {
  Datagrid,
  Filter,
  Record,
  Responsive,
  TextField,
  TextInput,
  useListContext,
} from "react-admin";
import { useSearchFields } from "../../../common/hooks/useSearchFields";
import { IResourceListProps } from "../../common/ra-types";
import { RouteComponentProps } from "react-router-dom";
import { Typography, useTheme } from "@material-ui/core";
import { DefaultProLogsList } from "../../common/list/DefaultProLogsList";
import { ProLogsEmpty } from "../../common/list/ProLogsEmpty";
import { RouterOutlined } from "@material-ui/icons";
import SelectSimpleList from "../../hos/unidentified-driving/SimpleSelectList";

interface Props extends IResourceListProps, Partial<RouteComponentProps> {}

interface SimpleListProps {
  record?: Record;
}

const ListFilter = (props: any) => {
  const { loading } = useListContext();
  useSearchFields(props, ["serialNumber"]);
  return (
    <Filter {...props}>
      {!loading && (
        <TextInput
          className="fleet-managers-list-filter search-box"
          label="resources.common.labels.search"
          source="q"
          alwaysOn
          autoFocus
          autoComplete="off"
        />
      )}
      {loading && (
        <TextInput
          className="fleet-managers-list-filter search-box"
          label="resources.common.labels.search"
          source="q"
          alwaysOn
        />
      )}
    </Filter>
  );
};

const RenderPrimaryTextForSimpleList = ({ record }: SimpleListProps) => {
  const theme = useTheme();
  return (
    <div
      style={{
        marginTop: "14px",
        display: "flex",
        flexDirection: "column",
        gap: "6px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1px",
          flexWrap: "wrap",
        }}
      >
        <Typography
          variant="body2"
          style={{ fontWeight: "600", color: theme.palette.text.secondary }}
        >
          ELD S/N:
        </Typography>
        <TextField
          record={record}
          source="serialNumber"
          label="resources.master-elds.labels.serialNumber"
        />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1px",
          flexWrap: "wrap",
        }}
      >
        <Typography
          variant="body2"
          style={{ fontWeight: "600", color: theme.palette.text.secondary }}
        >
          Assigned to tenant:
        </Typography>
        <TextField
          record={record}
          source="assignedToCustomer"
          label="resources.master-elds.labels.assignedToTenant"
        />
      </div>
    </div>
  );
};

export const TenantOwnEldsList = (props: Props) => {
  return (
    <div className="content-container">
      <DefaultProLogsList
        empty={<ProLogsEmpty iconType={RouterOutlined} />}
        className="content-list"
        title="resources.admin-tenant-own-elds.name"
        bulkActionButtons={false}
        actions={false}
        filters={<ListFilter />}
        sort={{ field: "serialNumber", order: "asc" }}
        {...props}
      >
        <Responsive
          small={
            <SelectSimpleList
              className="simple-list-wrapper"
              linkType="edit"
              primaryText={(record) => (
                <RenderPrimaryTextForSimpleList record={record} />
              )}
            />
          }
          medium={
            <Datagrid>
              <TextField
                source="serialNumber"
                label="resources.master-elds.labels.serialNumber"
              />
              <TextField
                source="assignedToCustomer"
                label="resources.master-elds.labels.assignedToTenant"
              />
            </Datagrid>
          }
        />
      </DefaultProLogsList>
    </div>
  );
};
